<router-outlet />

<span class="app-version-watermark" aria-hidden="true">v{{ appVersion }}</span>
